import React, { useState, useRef } from 'react';
import {
  Button,
  FormFeedback,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { ConditionClient } from '../../../../models/companies/kyccs/conditionClient';
import { handleAxiosError } from '../../../../../common/helpers/axiosHelper';
import { simpleFlashMessage } from '../../../../../common/utils/flashMessage';

type Props = {
  isOpen: boolean;
  kyccId: number;
  conditionId: number;
  note: string;
  onClose: () => void;
  onChangeNote: (note: string) => void;
};

export function EditNoteModal(props: Props) {
  const { isOpen, kyccId, conditionId, onClose, onChangeNote } = props;
  const [note, setNote] = useState<string>(props.note);
  const [updating, setUpdating] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const conditionClient = useRef(new ConditionClient());

  const onClickSubmit = () => {
    setUpdating(true);
    setError(null);

    conditionClient.current
      .updateNote(kyccId, conditionId, note)
      .then(response => {
        if (response.data.note != null) {
          onChangeNote(response.data.note);
        }
      })
      .catch(error => {
        if (error.response.status === 422) {
          setError(error.response.data.note[0]);
        } else {
          handleAxiosError(error, simpleFlashMessage);
        }
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const closeBtn = (
    <button className="close" onClick={onClose}>
      &times;
    </button>
  );

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader toggle={onClose} close={closeBtn}>
        メモの編集
      </ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <Input
            type="textarea"
            value={note}
            placeholder="30文字以内で入力してください"
            invalid={error != null}
            rows={8}
            onChange={event => setNote(event.target.value)}
          />
          {error != null && <FormFeedback>{error}</FormFeedback>}
        </div>
        <Button
          color="primary"
          size="lg"
          block
          onClick={onClickSubmit}
          disabled={updating}
        >
          保存
        </Button>
      </ModalBody>
    </Modal>
  );
}
